<template>
  <section class="p-1">
    <v-card>
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">Settlements</div>
        <div>
          <bread-crumb :bread-crumbs="['Settlements']" />
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>
      <v-card class="pa-2 ma-2" v-if="selected_deal" width="800">
        <v-row>
          <v-col sm="12" md="6" lg="6">
            <div class="menu-sec">
              <v-list-item
                class="d-flex justify-content-between align-items-center"
              >
                <small>Contract Type</small>
                <b>{{ selected_deal.deal_type }}</b>
              </v-list-item>
              <v-list-item
                class="d-flex justify-content-between align-items-center"
              >
                <small>Contract Number</small>
                <b>{{ selected_deal.deal_no }}</b>
              </v-list-item>
              <v-list-item
                class="d-flex justify-content-between align-items-center"
              >
                <small>Contract Person</small>
                <b>{{ selected_deal.bank_poc }}</b>
              </v-list-item>
              <v-list-item
                class="d-flex justify-content-between align-items-center"
              >
                <small>Fund in MYR</small>
                <b>{{ selected_deal.lcy_amount }} MYR</b>
              </v-list-item>
              <v-list-item
                class="d-flex justify-content-between align-items-center"
              >
                <small>Fund in USD</small>
                <b>{{ selected_deal.fcy_amount }} USD</b>
              </v-list-item>
            </div>
          </v-col>
          <v-col sm="12" md="6" lg="6" class="">
            <v-list-item
              class="d-flex justify-content-between align-items-center"
            >
              <small> Outstanding Amount:</small>
              <h3>{{ selected_deal.fcy_balance }} USD</h3>
            </v-list-item>
            <v-list-item
              class="d-flex justify-content-between align-items-center"
            >
              <small>Deal Status</small>
              <v-chip :color="getStatusColor(selected_deal.status)">
                {{ selected_deal.status }}
              </v-chip>
            </v-list-item>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ma-2">
        <v-card-text>
          <v-row justify="space-between">
            <v-col cols="6" lg="4" xs="12">
              <v-btn
                depressed
                small
                v-if="selected_deal && selected_deal.fcy_balance > 0"
                :disabled="selected_deal.status === 'settled'"
                color="primary text-capitalize"
                class="mr-2 action-btn"
                title="New Settlement"
                @click="newSettlementlick()"
              >
                <v-icon small>mdi-plus</v-icon>Add
              </v-btn>
              <v-btn depressed @click="downloadExcelsheet" color="primary" small
                ><v-icon small>mdi-file-excel-outline</v-icon>Export
              </v-btn>
            </v-col>
            <v-col cols="6" lg="4" xs="12">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Type here to filter the table data."
                hide-details
                dense
                clearable
                single-line
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-data-table fixed-header  height="55vh"
          :headers="headers"
          :items="items"
          :single-expand="true"
          :expanded.sync="expanded"
          item-key="settl_id"
          show-expand
          :search="search"
          class="py-4"
          dense
        >
          <template v-slot:item.action="{ item }">
            <div class="d-flex">
              <v-icon
                small
                title="Edit"
                color="primary"
                class="mr-2"
                @click="onclickUpdate(item)"
              >
                mdi-content-save-edit-outline
              </v-icon>
              <v-icon
                small
                title="Delete"
                color="primary"
                class="mr-2"
                @click="deleteItem(item)"
              >
                mdi-trash-can-outline
              </v-icon>
              <v-icon
                small
                title="Funding"
                color="primary"
                class="mr-2"
                @click="newFundClicked(item)"
              >
                mdi-chevron-right-circle-circle-outline
              </v-icon>
            </div>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <v-row justify="space-between">
                <v-col cols="12" lg="12" xs="12">
                  <v-row justify="space-between">
                    <span class="text-h6 font-weight-light title-lbl"
                      >Additional Info</span
                    >
                    <v-col cols="12" lg="6" xs="12">
                      <div class="menu-sec">
                       
                        <v-list-item class="v-flex">
                          <label>Purchase Date</label>
                          <b>{{ format(item.purchase_date) }}</b>
                        </v-list-item>
                        <v-list-item class="v-flex">
                          <label>Swift Charge</label>
                          <b>{{ item.swift_charge }}</b>
                        </v-list-item>
                        <v-list-item class="v-flex">
                          <label>Bank Charge</label>
                          <b>{{ item.bank_charge }}</b>
                        </v-list-item>
                      </div>
                    </v-col>
                    <v-col cols="12" lg="6" xs="12">
                      <div class="menu-sec">
                        <v-list-item class="v-flex">
                          <label>Service Tax</label>
                          <b>{{ item.service_tax }}</b>
                        </v-list-item>
                        <v-list-item class="v-flex">
                          <label>Created by</label>
                          <b>{{ item.created_by }}</b>
                        </v-list-item>
                        <v-list-item class="v-flex">
                          <label>Updated by</label>
                          <b>{{ item.updated_by }}</b>
                        </v-list-item>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </td>
          </template>
        </v-data-table>
        <!-- delete dialog -->
        <v-dialog persistent v-model="dialogDelete" width="500">
          <v-card>
            <v-card-title class="border border-bottom">Delete</v-card-title>
            <v-card-text class="h5 py-3"
              >Are you sure you want to delete?</v-card-text
            >
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                depressed
                small
                color="primary"
                outlined
                @click="deleteItemConfirm"
              >
                <v-icon>mdi-check</v-icon>
              </v-btn>
              <v-btn
                depressed
                small
                color="primary"
                outlined
                @click="(dialogDelete = false), (deleteId = null)"
                ><v-icon>mdi-close</v-icon></v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card>
    </v-card>
    <OverlayPageVue :showOverlay="loaderOverlay" />
  </section>
</template>

<script>
import OverlayPageVue from "@/utils/OverlayPage.vue";
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import treasuryService from "@/services/TreasuryService/treasuryService.js";
import alerts from "@/mixins/alerts";
export default {
  name: "Settlements",
  mixins: [alerts],
  components: {
    BreadCrumb,
    OverlayPageVue,
  },
  data() {
    return {
      expanded: [],
      dialogDelete: false,
      deleteId: null,
      search: "",
      updateTrigger: false,
      selected_deal: null,
      deal_id_number: null,
      loaderOverlay: false,
      deal_details: [],
      partner_balance: [],
      amountExceedError: "",
      amountValidity: "pending",
      apiSideMessage: "",

      headers: [
        {
          value: "settl_id",
          text: "ID",
          sortable: false,
        },
        {
          value: "payout_partner",
          text: "Payout Partner",
          sortable: false,
        },
        {
          value: "settl_date",
          text: "Settlement Date",
          sortable: false,
        },
        {
          value: "deal_no",
          text: "Contract Number",
          sortable: false,
        },
        {
          value: "credit_amount",
          text: "USD Amount",
          sortable: false,
        },
        {
          value: "fcy_deal_rate",
          text: "Contract Rate",
          sortable: false,
        },
        {
          value: "action",
          text: "Actions",
          sortable: false,
        },
        { text: "", value: "data-table-expand", sortable: false, width: 50 },
      ],
      items: [],
    };
  },
  computed: {},
  mounted() {
    this.deal_id_number = this.$route.query.id;
    if (this.deal_id_number) {
      this.getSelectedDealDtl();
      this.getSelecedDealSetlement(this.deal_id_number);
    }
  },
  watch: {},
  methods: {
    getStatusColor(status) {
      if (status === "open") {
        return "info";
      } else if (status === "close") {
        return "error";
      } else if (status === "settled") {
        return "success";
      } else {
        return "grey";
      }
    },
    stoploader() {
      setTimeout(() => {
        this.loaderOverlay = false;
      }, 400);
    },
    async downloadExcelsheet() {
      if (this.items) {
        this.exportToExcel(this.headers, this.items, "Settlement");
      }
    },

    async getSelecedDealSetlement() {
      if (!this.deal_id_number) {
        return;
      }
      this.loaderOverlay = true;
      try {
        const responseData = await treasuryService.getSelectedSettledDeal(
          this.deal_id_number
        );
        if (responseData && responseData.data.status_code == 200) {
          this.items = JSON.parse(JSON.stringify(responseData.data.data[0]));
          this.stoploader();
        } else {
          // this.showAlertError("Failed I:" + responseData.data.message);
          this.loaderOverlay = false;
        }
        console.log("response data", responseData);
        console.log("this.items", this.items);
      } catch (e) {
        console.log(e);
        this.showAlertError("Fetched data Failed: Something went wrong");
      }
    },
    async getSelectedDealDtl() {
      this.loaderOverlay = true;
      try {
        const responseData = await treasuryService.getSelectedDeal(
          this.deal_id_number
        );
        if (responseData && responseData.data.status_code == 200) {
          this.selected_deal = responseData.data.data[0];
          this.stoploader();
        } else {
          // this.showAlertError("Failed:" + responseData.data.message);
        }
        console.log("response data", responseData);
      } catch (e) {
        console.log(e);
        this.loaderOverlay = false;
        this.showAlertError("Fetched data Failed: Something went wrong");
      }
    },

    format(date) {
      if (date) {
        date = new Date(date);
        let month = date.toLocaleString("en-US", { month: "short" });
        return date.getDate() + " " + month + " " + date.getFullYear();
      }
    },
    deleteItem(item) {
      this.dialogDelete = true;
      this.deleteId = item.settl_id;
    },
    async deleteItemConfirm() {
      this.loaderOverlay = true;
      try {
        const responseData = await treasuryService.deleteSettlementDeal(
          this.deleteId
        );
        if (responseData && responseData.data.status_code == 200) {
          this.showAlertSuccess(responseData.data.message);
          this.getSelecedDealSetlement(this.deal_id_number);
          this.getSelectedDealDtl();
          this.dialogDelete = false;
          this.stoploader();
        } else {
          this.showAlertError("Failed:" + responseData.data.message);
          this.loaderOverlay = false;
        }
      } catch (e) {
        console.log(e);
        this.loaderOverlay = false;
        this.showAlertError("Fetched data Failed: Something went wrong");
      }
    },
    onclickUpdate(selectedRow) {
      this.$router.push({
        name: "NewSettlement",
        query: { id: selectedRow.settl_id },
      });
    },
    newFundClicked(selectedRow) {
      this.$router.push({
        name: "Funding",
        query: { settle_id: selectedRow.settl_id },
      });
    },
    newSettlementlick() {
      console.log("selected_deal", this.selected_deal);
      this.$router.push({
        name: "NewSettlement",
        query: {
          deal_id: this.selected_deal.deal_id,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/global.scss";
.title-lbl {
  width: 100%;
  padding: 5px;
  text-align: center;
  font-weight: bold;
  color: $txt;
  border-bottom: 1px solid $txt;
}
.col-p5 {
  padding-right: 5px !important;
  padding-left: 5px !important;
}

.menu-sec {
  margin-top: 0.5rem;
  .v-list-item {
    min-height: 36px;
    label {
      width: 30%;
    }
  }
}
.card-body {
  padding: 0 !important;
}
.card {
  margin-bottom: 1rem !important;
}

.row {
  margin: 5px;
}

.action-div {
  text-align: end;
}
::v-deep .table {
  td {
    vertical-align: middle !important;
  }
}
.form-group {
  margin-bottom: 0;
}
.list-group-item {
  padding: 0;
}
</style>
